import 'arrive';
import Swiper from 'swiper/bundle';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Helper: format numbers with optional thousands separator
function formatNumber(value, decimals = 0, sep = '.') {
  const n = Number(value);
  if (!isFinite(n)) return String(value);
  const fixed = n.toFixed(decimals);
  const [int, dec] = fixed.split('.');
  const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return dec ? `${withSep}${dec ? ',' + dec : ''}` : withSep;
}

// Robust parse from text content
function parseNumberFromText(el) {
  const raw = (el.textContent || '').trim();
  if (!raw) return 0;
  // keep digits, dots and commas; normalize comma to dot; remove extra dots if both present
  const cleaned = raw.replace(/[^0-9.,-]/g, '');
  // If both comma and dot exist, assume dot is thousands and comma is decimal
  if (cleaned.includes(',') && cleaned.includes('.')) {
    return parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) || 0;
  }
  // Otherwise, replace comma with dot
  return parseFloat(cleaned.replace(',', '.')) || 0;
}

// Initialize counters within a block (no ScrollTrigger here; controlled externally)
function initCounters(block) {
  const counters = block.querySelectorAll('.counter');
  const anims = [];
  counters.forEach((el) => {
    if (el.dataset.counterInitialized === 'true') return;
    el.dataset.counterInitialized = 'true';

    const end = parseFloat(el.getAttribute('data-target')) || parseNumberFromText(el) || 0;
    const start = parseFloat(el.getAttribute('data-start') || '0') || 0;
    const duration = parseFloat(el.getAttribute('data-duration') || '1.2') || 1.2;
    const decimals = Math.max(0, parseInt(el.getAttribute('data-decimals') || '0', 10));
    const sep = el.getAttribute('data-sep') || '.';

    // reset initial text
    el.textContent = formatNumber(start, decimals, sep);

    const obj = { val: start };
    const tween = gsap.to(obj, {
      val: end,
      duration,
      ease: 'power2.out',
      paused: true,
      onUpdate: () => {
        el.textContent = formatNumber(obj.val, decimals, sep);
      },
      onComplete: () => {
        el.textContent = formatNumber(end, decimals, sep);
      }
    });
    anims.push(tween);
  });
  return anims;
}

document.arrive('.block-counters', { existing: true }, function (el) {
  // slider
  const container = el.querySelector('.block-counters__grid.swiper');
  if (container && container.dataset.swiperInitialized !== 'true') {
    container.dataset.swiperInitialized = 'true';
    new Swiper(container, {
      slidesPerView: 1.2,
      spaceBetween: 24,
      loop: false,
      freeMode: true,
      allowTouchMove: true,
      breakpoints: {
        1080: { slidesPerView: 3, spaceBetween: 24 },
        600: { slidesPerView: 2.2, spaceBetween: 24 },
        550: { slidesPerView: 1.2, spaceBetween: 24 },
      },
    });
  }

  // counters: prepare tweens and trigger them when section enters viewport
  const tweens = initCounters(el);
  if (tweens.length) {
    ScrollTrigger.create({
      trigger: el,
      start: 'top center',
      once: true,
      onEnter: () => {
        tweens.forEach(t => t.play());
      }
    });
  }
});